// extracted by mini-css-extract-plugin
module.exports = {"header":"components-topicList-topicList__header--2CDOi","slidersLink":"components-topicList-topicList__slidersLink--aTrYg"};